import { useEffect, useState } from "react";
import axiosInstance from "../components/api/axiosInstance";

let cache = null;
let pending = null;

function loadOwners() {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = axiosInstance
      .get("/clients", { params: { include_inactive: 1 } })
      .then((res) => {
        const raw = Array.isArray(res.data) ? res.data : Array.isArray(res.data?.data) ? res.data.data : [];
        const seen = new Set();
        const owners = [];
        for (const item of raw) {
          const c = item?.client || item;
          if (!c) continue;
          const name = `${c.First_Name || ""} ${c.Last_Name || ""}`.replace(/\s+/g, " ").trim();
          if (!name) continue;
          const email = String(c.Email || "").trim();
          const key = `${name.toLowerCase()}|${email.toLowerCase()}`;
          if (seen.has(key)) continue;
          seen.add(key);
          owners.push({
            name,
            email,
            countryCode: c.Country_Code || "",
            phone: c.Phone || "",
            company: String(c.Company_Name || "").trim()
          });
        }
        owners.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
        cache = owners;
        return owners;
      })
      .catch(() => [])
      .finally(() => {
        pending = null;
      });
  }
  return pending;
}

/** Client owners (all statuses) as [{name, email, countryCode, phone, company}], cached per page load. */
export default function useOwnerSuggestions() {
  const [owners, setOwners] = useState(() => cache || []);
  useEffect(() => {
    let cancelled = false;
    loadOwners().then((rows) => {
      if (!cancelled) setOwners(rows);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return owners;
}
